import styled from '@emotion/styled';

export const DetailInfoWrapper = styled('div')(
  () => `
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        
        .title {
            font-size: 16px;
            width: 30%;
            margin-bottom: 20px;
        }
        .content {
            font-size: 16px;
            width: 70%;
            margin-bottom: 20px;
        }
    `,
);
